import { render } from "./PatientPortal.vue?vue&type=template&id=28288e2b&scoped=true"
import script from "./PatientPortal.vue?vue&type=script&lang=js"
export * from "./PatientPortal.vue?vue&type=script&lang=js"

import "./PatientPortal.vue?vue&type=style&index=0&id=28288e2b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28288e2b"]])

export default __exports__